export const LiveDot = ({ lastSync, testid = "live-indicator" }) => (
  <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-slate-500" data-testid={testid}>
    <span className="relative flex h-2 w-2">
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-500 opacity-70" />
      <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-600" />
    </span>
    Live
    {lastSync && <span className="font-mono font-normal normal-case text-slate-400">· {lastSync.toLocaleTimeString()}</span>}
  </span>
);

export default LiveDot;
